import {default as React, useState} from "react";
import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import {CardObject} from "../../../types.d";
import {beautifyFalseAnswers, beautifyInfinitives} from "../../../utils/falseAnswers";
import {approvedText, escalationText} from "../../../utils/approvedText";

interface VocabularyModalProps {
    card: CardObject;
    visible: boolean;
    toggle: () => any;
}

export const ExerciseModal = (props: VocabularyModalProps) => {
    const { card } = props;

    return <Modal isOpen={props.visible}
                  className={'large-modal'}
                  toggle={props.toggle}>
        <ModalHeader toggle={props.toggle}>{ card.explanation.postTitle } { card.postTitle }</ModalHeader>
        <ModalBody>
            <div className="modal-body">
                <p className="card-text text-left">
                    <b>Exercise: </b>
                    <span dangerouslySetInnerHTML={{ __html: card.explanationRules }} />
                    <br/>
                    <b>False answers:</b>
                    { beautifyFalseAnswers(card.falseAnswers) }
                    <br/>
                    <b>Translation: </b>
                    <span dangerouslySetInnerHTML={{ __html: card.exerciseTranslation }} />
                    <br/>
                    <b>Infinitives only: </b>
                    {beautifyInfinitives(card.infinitivesOnly)}
                </p>

                <p>
                    <strong>Card Creator: </strong> {card.creatorName}<br/>
                    { card.approvingName && (
                        <>
                            <strong>Approving: </strong> {card.approvingName} { approvedText(card.approvedAt, card.disapprovedAt) }<br/>
                        </>
                    ) }
                </p>

                { card.reviewDescription && (
                    <div style={{ backgroundColor: 'red', color: 'white' }}>
                        <strong>Comment:</strong>
                        <p style={{ whiteSpace: 'pre' }}>{ card.reviewDescription }</p>
                    </div>
                ) }

                { card.escalatingName && (
                    <p>
                        <strong>Escalating: </strong> {card.escalatingName} { escalationText(card) }<br/>
                    </p>
                ) }
            </div>
        </ModalBody>
    </Modal>
};
